import React, { useEffect, useState } from 'react'
import { 
  Button,
  Grid,
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TablePagination, 
  TableRow 
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGrupos } from '../../../../../actions/autorizaciones/practicasAgrupadas';
import { GruposLaboratorioItem } from './GruposLaboratorioItem';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { setGruposSeleccionadosLaboratorio } from '../../../../../actions/turnos/laboratorio';
import { setShowForm } from '../../../../../actions/autorizaciones/Autorizaciones';

export const  GruposLaboratorio = ({ingresoCab = false}) => {
  const dispatch = useDispatch();

  const { grupos: items } = useSelector((state) => state.practicasAgrupadas);

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    dispatch(fetchGrupos());
  }, [dispatch])

  const submitHandler = (e) => {    
    e.preventDefault();    
    
    const gruposSeleccionados = [];

    for (const [index, grupo] of items.entries()) {
      const checked = e.target.elements[`grupo-${index}`]?.checked;
      
      if (checked) {
        gruposSeleccionados.push({
          idGrupo: grupo.id,
          nombre: grupo.nombre,
        });
      }
    }
  
    dispatch( setGruposSeleccionadosLaboratorio(gruposSeleccionados, ingresoCab) );
    if(ingresoCab)  
      dispatch(setShowForm(true));
  };

  return (
    <ValidatorForm onSubmit={submitHandler}>
      <Grid container justify="center">
        {items.length > 0 ? (
          <Table size={"small"}>
            <TableHead
              style={{ display: "table", width: "98.5%", tableLayout: "fixed" }}
            >
              <TableRow>
                <TableCell style={{ width: "15%" }}></TableCell>
                <TableCell style={{ width: "85%" }}>Nombre</TableCell>
              </TableRow>
            </TableHead>
            <TableBody
              style={{ display: "block", maxHeight: "29rem", overflowY: "auto" }}
            >
              {items.length > 0 && (
                items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {            
                  return (
                    <GruposLaboratorioItem item={item} key={index} index={index} />
                  );
                }))}  
            </TableBody>
          </Table>
        ) : (
          <div style={{ fontStyle: "italic", marginTop: 25, marginLeft: 25 }}>No hay practicas</div>
        )}
        {items.length > 0 && (
          <Grid item xs={12}>
            <TablePagination
              style={{ backgroundColor: "white" }}
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={items.length}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage="Registros por página"
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Grid>
        )}
      </Grid>
      <Button id="btnSubmitLaboratorioStep2" style={{display: 'none'}} type="submit">
        Submit
      </Button>
    </ValidatorForm>
  )
}
